import { useTranslation } from 'react-i18next';
import { PageTitle } from '../shared/Typography/PageTitle';
import {
    Box,
    Grid,
    Skeleton,
    Typography,
    useMediaQuery,
    useTheme,
} from '@mui/material';
import { CollectionWrapper } from './CollectionWrapper';
import { CollectionFilter } from './CollectionFilter/CollectionFilter';
import { useEffect, useState } from 'react';
import { CollectionFilteredItems } from '../../models/CollectionFilter';
import { CollectionProps } from '../../models/Collection';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { filterActions } from 'redux/slices/filterSlice';

export const Collection: React.FC<CollectionProps> = (props) => {
    const {
        handle,
        collection,
        collectionId,
        isCollectionIdLoading,
        isLoading,
        search,
    } = props;

    const dispatch = useAppDispatch();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('lg'));
    const { t } = useTranslation('collection', {
        keyPrefix: 'COLLECTIONS',
    });

    const { filter } = useAppSelector((state) => state.filter);

    useEffect(() => {
        dispatch(
            filterActions.setCollectionFilter({
                priceRange: [],
                filteredItems: [],
            })
        );
    }, [collectionId, isCollectionIdLoading]);
    const handleFilter = (items) => {
        dispatch(filterActions.setCollectionFilter(items));
    };

    return (
        <>
            <Grid container spacing={2}>
                {!isMobile && (
                    <Grid item xs={2}>
                        <Typography
                            variant="h2"
                            gutterBottom
                            sx={{ marginBottom: '1rem' }}
                        >
                            {t('FILTER')}
                        </Typography>
                        <CollectionFilter
                            handleFilter={handleFilter}
                            collectionId={collectionId}
                            search={search}
                            preSetItems={filter.filteredItems}
                            priceRange={filter.priceRange}
                        />
                    </Grid>
                )}
                <Grid item xs>
                    <Box>
                        {isLoading && (
                            <Skeleton
                                variant="text"
                                sx={{ fontSize: '1rem' }}
                            />
                        )}
                        <PageTitle>
                            {search
                                ? 'TALÁLAT ERRE: ' + search
                                : collection && collection.title}
                        </PageTitle>
                        <Box>{t('QUATATION_DESC')}</Box>
                    </Box>
                    <CollectionWrapper
                        collectionIds={collectionId ? [collectionId] : []}
                        search={search}
                        handle={handle}
                    />
                </Grid>
            </Grid>
        </>
    );
};
